/**
 * PostHog analytics for client-v4.
 * Init only when /api/config returns posthogKey (same gate as app.html).
 */
import posthog from 'posthog-js'

let ready = false

export function isPosthogReady(): boolean {
  return ready
}

/** Used by unit tests to reset module state. */
export function _resetPosthogForTests(): void {
  ready = false
}

/** Mark ready without network — unit tests only. */
export function _markPosthogReadyForTests(): void {
  ready = true
}

export async function initPosthogFromConfig(): Promise<void> {
  try {
    const res = await fetch('/api/config')
    if (!res.ok) return
    const cfg = (await res.json()) as { posthogKey?: string }
    if (!cfg.posthogKey) return
    posthog.init(cfg.posthogKey, {
      api_host: 'https://us.i.posthog.com',
      person_profiles: 'identified_only',
      capture_pageview: true,
      autocapture: false,
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: '*',
      },
    })
    ready = true
  } catch {
    /* analytics optional */
  }
}

export function identifyUser(user: {
  id: number
  email: string
  company_name?: string | null
  created_at?: string
  user_role?: string | null
}): void {
  if (!ready) return
  try {
    const props: Record<string, string | number> = { email: user.email }
    if (user.company_name) props.company = user.company_name
    if (user.created_at) props.created_at = user.created_at
    if (user.user_role) props.role = user.user_role
    posthog.identify(String(user.id), props)
  } catch {
    /* ignore */
  }
}

export function resetPosthog(): void {
  if (!ready) return
  try {
    posthog.reset()
  } catch {
    /* ignore */
  }
}

export function captureEvent(
  event: string,
  props?: Record<string, string | number | boolean | null | undefined>,
): void {
  if (!ready) return
  try {
    const clean: Record<string, string | number | boolean> = {}
    if (props) {
      for (const [k, v] of Object.entries(props)) {
        if (v === null || v === undefined) continue
        clean[k] = v
      }
    }
    posthog.capture(event, clean)
  } catch {
    /* ignore */
  }
}
